/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_5_TitleInputs */

const en_vc_ft_5_title = /** @type {(inputs: Vc_Ft_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Revolve`)
};

const zh_vc_ft_5_title = /** @type {(inputs: Vc_Ft_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D 绕转`)
};

/**
* | output |
* | --- |
* | "3D Revolve" |
*
* @param {Vc_Ft_5_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_5_title = /** @type {((inputs?: Vc_Ft_5_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_5_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_5_title(inputs)
	return zh_vc_ft_5_title(inputs)
});
export { vc_ft_5_title as "vc.ft.5.title" }